// Landing (see CONTEXT.md): a visit always opens on the page the landing
// rule picks, never at the URL it was opened with.

const LANDING_AFTER_HIDDEN_MS = 60 * 60 * 1000;

function landingDisabled(): boolean {
  return (
    (window as { __E2E_NO_LANDING__?: boolean }).__E2E_NO_LANDING__ === true
  );
}

/**
 * Landing on a full load: rewrite the path to `/` before the router reads it.
 * Query and hash are kept, so nothing an auth round-trip may carry is lost.
 */
export function landOnLoad(): void {
  if (landingDisabled() || window.location.pathname === "/") return;
  window.history.replaceState(
    window.history.state,
    "",
    `/${window.location.search}${window.location.hash}`,
  );
}

/**
 * Landing on return: calls `land` when the app becomes visible after being
 * hidden for an hour or more. Wall-clock time, since a sleeping phone does
 * not advance the monotonic clock. Returns an unsubscribe function.
 */
export function landOnReturn(land: () => void): () => void {
  let hiddenAt: number | null =
    document.visibilityState === "hidden" ? Date.now() : null;
  const onVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      hiddenAt = Date.now();
      return;
    }
    const hiddenFor = hiddenAt === null ? 0 : Date.now() - hiddenAt;
    hiddenAt = null;
    if (hiddenFor >= LANDING_AFTER_HIDDEN_MS && !landingDisabled()) land();
  };
  document.addEventListener("visibilitychange", onVisibilityChange);
  return () =>
    document.removeEventListener("visibilitychange", onVisibilityChange);
}
